export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  publishedAt: string;
  imageUrl: string;
  tags: string[];
  views: number;
  isHot: boolean;
  isExclusive: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '娱乐圈黑料', slug: 'yule', description: '明星八卦、娱乐圈内幕、影视圈潜规则独家揭秘', icon: 'ri-movie-2-line', count: 128 },
  { name: '社会热点', slug: 'shehui', description: '社会事件深度调查、热点新闻幕后真相', icon: 'ri-fire-line', count: 96 },
  { name: '政商内幕', slug: 'zhengshang', description: '政商关系、商业黑幕、资本运作深度挖掘', icon: 'ri-building-2-line', count: 74 },
  { name: '网红黑料', slug: 'wanghong', description: '网红圈爆料、直播界潜规则、KOL真实面目', icon: 'ri-live-line', count: 85 },
  { name: '独家爆料', slug: 'dujia', description: '全网独家首发、第一手内幕资讯', icon: 'ri-spy-line', count: 52 },
  { name: '深度调查', slug: 'shendu', description: '长文深度报道、调查记者一线实录', icon: 'ri-search-eye-line', count: 41 },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，酒店同框照流出，工作室紧急公关',
    excerpt: '据知情人士透露，该男星近期与一位圈外女性交往密切，两人被拍到在同一酒店出入。消息曝光后，其工作室已启动紧急公关预案，试图压下相关报道。',
    content: `<p>近日，有网友在社交平台晒出一组照片，显示某当红男星深夜与一名神秘女子先后进入北京某五星级酒店。据拍摄者描述，两人间隔约五分钟分别进入，似乎在刻意避嫌。</p><p>据圈内知情人士透露，该男星近期确实与一位圈外女性交往密切，对方并非娱乐圈人士，而是一位从事金融行业的白领。两人通过朋友介绍相识，目前已交往约三个月。</p><p>消息在网络上迅速发酵后，该男星的工作室连夜启动紧急公关预案，多方联系媒体试图压下相关报道。有消息称，工作室已向多家娱乐媒体发出律师函，要求删除相关内容。</p><p>值得注意的是，该男星此前一直以"单身"人设示人，在综艺节目中也多次表示"专注事业、暂无恋爱计划"，此番被拍到实锤，恐对其商业代言造成影响。目前已有品牌方表示将密切关注事态发展。</p><p>截至发稿，该男星本人及其工作室尚未对此事作出公开回应。</p>`,
    category: '娱乐圈黑料',
    categorySlug: 'yule',
    author: '911调查组',
    publishedAt: '2026-08-04T22:30:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20male%20celebrity%20in%20dark%20suit%20walking%20into%20luxury%20hotel%20at%20night%2C%20paparazzi%20style%20candid%20shot%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20photography%2C%20warm%20street%20lights%20reflecting%20on%20wet%20pavement%2C%20blurred%20background%2C%20high%20contrast%2C%20editorial%20style&width=800&height=450&seq=yule-01&orientation=landscape',
    tags: ['顶流男星', '恋情曝光', '酒店密会', '公关危机'],
    views: 285600,
    isHot: true,
    isExclusive: true,
  },
  {
    id: '2',
    title: '知名女星偷税漏税内幕：阴阳合同金额曝光，涉及金额超2亿',
    excerpt: '税务部门内部人士透露，某知名一线女星通过阴阳合同、拆分片酬等方式，在三年内偷逃税款超过2亿元。目前案件正在进一步调查中。',
    content: `<p>据税务系统内部知情人士向本网透露，某知名一线女星涉嫌通过签订"阴阳合同"、拆分片酬等多种方式，在2018年至2021年期间偷逃个人所得税及增值税共计超过2亿元人民币。</p><p>消息人士称，该女星在多部大制作影视剧中的实际片酬远高于对外公布的金额。以某部2020年上映的电影为例，其对外公布片酬为800万元，而实际片酬高达5000万元，差额部分通过关联公司以"咨询服务费"、"策划费"等名目走账。</p><p>此外，该女星还涉嫌通过设立多家空壳公司在税收洼地注册，将个人劳务报酬转化为企业经营收入，以此逃避高额个人所得税。据统计，仅此一项，三年间就涉及逃税金额超过8000万元。</p><p>目前，税务机关已掌握大量证据材料，案件正在进一步调查中。若查实，该女星将面临补缴税款、滞纳金及罚款，总金额可能超过4亿元。</p><p>业内人士分析，此案曝光后，预计将对整个娱乐圈的税务合规产生重大影响，或将引发新一轮的行业自查风暴。</p>`,
    category: '娱乐圈黑料',
    categorySlug: 'yule',
    author: '911调查组',
    publishedAt: '2026-08-03T18:15:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20actress%20in%20luxurious%20outfit%20standing%20near%20financial%20documents%20and%20contracts%20on%20a%20dark%20desk%2C%20dramatic%20shadow%20lighting%2C%20moody%20atmosphere%2C%20investigative%20journalism%20aesthetic%2C%20warm%20amber%20and%20dark%20tones%2C%20cinematic%20photography%2C%20high%20detail&width=800&height=450&seq=yule-02&orientation=landscape',
    tags: ['偷税漏税', '阴阳合同', '女星', '税务调查'],
    views: 432100,
    isHot: true,
    isExclusive: true,
  },
  {
    id: '3',
    title: '某直播平台一姐堕胎门事件：前男友爆料录音曝光，聊天记录流出',
    excerpt: '一位自称是该网红前男友的网友公开了一段录音和多张聊天截图，指控其在交往期间隐瞒已婚身份并多次索要巨额财物。',
    content: `<p>近日，一位自称是某头部直播平台"一姐"的前男友的网友在社交平台发布长文，并附上多段录音和聊天记录截图，详细揭露了两人交往期间的内幕。</p><p>该网友称，他与该网红于2025年初开始交往，期间女方一直声称自己单身。然而在今年3月，他意外发现女方其实早已结婚，并在与他交往的同时还与其他多名男性保持暧昧关系。</p><p>更令人震惊的是，录音中女方承认曾为另一名富商堕胎，并详细描述了堕胎的经过。录音中还提到，女方曾多次以"投资"、"买房"等名义向其索要钱财，累计金额超过500万元。</p><p>曝光的聊天记录显示，女方在与该网友交往期间，同时与至少三名男性保持密切关系，其中包括一位知名企业家和一位影视投资人。聊天内容露骨，涉及大量金钱交易。</p><p>此事件在网络上引发轩然大波，相关话题迅速登上热搜。该网红目前尚未对此事作出回应，其直播间已被大量网友涌入刷屏质问。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    author: '911编辑部',
    publishedAt: '2026-08-04T15:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20live%20streamer%20with%20headphones%20sitting%20in%20a%20dimly%20lit%20room%2C%20computer%20screen%20glowing%2C%20mysterious%20vibe%2C%20purple%20and%20red%20neon%20accents%2C%20dark%20moody%20photography%2C%20cinematic%20noir%20style&width=800&height=450&seq=wanghong-01&orientation=landscape',
    tags: ['网红', '堕胎门', '录音曝光', '聊天记录'],
    views: 356200,
    isHot: true,
    isExclusive: true,
  },
  {
    id: '4',
    title: '某互联网巨头CEO涉嫌权色交易：多名女员工实名举报材料曝光',
    excerpt: '一份来自该公司内部的多名女员工联合实名举报材料在网络流传，指控该CEO利用职权胁迫多名女性下属发生不正当关系。',
    content: `<p>昨日晚间，一份署名为"XXX公司受害女员工联盟"的实名举报材料在社交平台广泛传播。材料中，多达7名女性员工实名举报该公司CEO李某利用职务之便，对多名女性下属实施性骚扰并胁迫发生不正当关系。</p><p>举报材料详细记录了每一起事件的时间、地点和具体经过。其中最早的一起可追溯到2023年，最近的一起发生在今年6月。举报人提供了包括微信聊天记录、内部邮件、酒店入住记录等多项证据。</p><p>据材料描述，李某通常以"单独汇报工作"、"出差陪同"等名义将女员工叫到办公室或酒店房间，随后以升职加薪为诱饵，或以辞退为威胁，迫使对方就范。多名举报人表示，事后曾向公司HR部门投诉，但均被以"证据不足"为由压了下来。</p><p>此事曝光后，该公司股价在次日开盘即暴跌8%。公司董事会紧急发布声明，称已成立独立调查委员会，将对举报内容进行全面调查，并承诺在30日内公布调查结果。</p><p>法律界人士指出，若举报内容属实，李某的行为已涉嫌构成强制猥亵罪和滥用职权罪，可能面临刑事处罚。</p>`,
    category: '政商内幕',
    categorySlug: 'zhengshang',
    author: '911调查组',
    publishedAt: '2026-08-04T09:45:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20silhouette%20at%20dusk%2C%20dramatic%20storm%20clouds%20approaching%2C%20glass%20windows%20reflecting%20orange%20sunset%2C%20foreboding%20atmosphere%2C%20corporate%20scandal%20concept%2C%20cinematic%20wide%20shot%2C%20dark%20and%20moody%20tone&width=800&height=450&seq=zhengshang-01&orientation=landscape',
    tags: ['互联网巨头', '权色交易', '实名举报', 'CEO'],
    views: 521800,
    isHot: true,
    isExclusive: true,
  },
  {
    id: '5',
    title: '某知名综艺节目黑幕大起底：选手排名早已内定，评审费明码标价',
    excerpt: '一位曾经参与该节目的工作人员独家向本网透露，节目中的选手排名在录制前就已经确定，所谓的"观众投票"纯属走过场。',
    content: `<p>近日，一位曾在某卫视知名选秀综艺节目中担任幕后工作人员的消息人士联系到本网，详细揭露了该节目背后的一系列运作黑幕。</p><p>据该人士透露，节目中的选手排名在每一轮录制开始前就已经由导演组和赞助商共同确定。"前几名基本都是赞助商指定的选手，或者是与节目组有签约关系的艺人。所谓的观众投票、评审打分，全都是走个形式。"</p><p>更令人震惊的是，该人士曝出了一份所谓的"评审费价目表"。据称，想要在节目中获得较高排名，选手或其经纪公司需要向节目组支付不同档次的"推广费"。进入前十名需要支付约300-500万元，前五名则需要800-1500万元不等。</p><p>此外，该人士还透露，节目中出现的"感人故事"、"励志经历"大多都是编剧团队提前撰写好的剧本。"每个选手都有一个'人设'，观众看到的所谓真情流露，其实都是按照剧本在演。"</p><p>该节目目前正在播出第三季，收视率一直名列前茅。本网已就此事向该卫视发出采访函，截至发稿尚未收到回复。</p>`,
    category: '娱乐圈黑料',
    categorySlug: 'yule',
    author: '911编辑部',
    publishedAt: '2026-08-03T11:20:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20talent%20show%20stage%20with%20bright%20spotlights%20and%20empty%20audience%20seats%2C%20lonely%20microphone%20stand%20at%20center%2C%20dramatic%20lighting%20contrast%2C%20behind%20the%20scenes%20exposed%20concept%2C%20dark%20backstage%20view%2C%20cinematic%20photography&width=800&height=450&seq=yule-03&orientation=landscape',
    tags: ['综艺黑幕', '选秀', '内定', '评审费'],
    views: 198300,
    isHot: false,
    isExclusive: true,
  },
  {
    id: '6',
    title: '某二线城市地产腐败案：副市长与开发商利益输送链条完整曝光',
    excerpt: '独家获取的内部审计报告显示，该市副市长通过亲属代持、虚假交易等方式，与多家房地产开发商形成了一条完整的利益输送链。',
    content: `<p>本网独家获取了一份来自审计部门的内部报告，详细揭露了某二线城市副市长张某与当地多家房地产开发商之间的利益输送链条。</p><p>报告显示，在过去五年间，张某通过其妻弟和表妹作为"白手套"，以明显低于市场价的价格从多家开发商手中购入多套房产和商铺，转手后获取巨额差价。据不完全统计，仅此一项涉及的非法收益就超过6000万元。</p><p>此外，张某还被指控在土地出让、规划审批、竣工验收等多个环节为特定开发商提供便利。作为回报，这些开发商通过第三方公司将"咨询费"打入张某亲属控制的账户。</p><p>报告披露了一个典型案例：2024年，某开发商以挂牌底价获取了一块规划为商业用地的优质地块，而实际上当时至少有5家开发商对该地块表达了意向。事后调查发现，该地块的出让条件被精心设计，使得其他开发商无法满足竞拍资格。</p><p>目前，该案已移交纪检监察部门处理。据悉，张某及其涉案亲属已被采取留置措施。</p>`,
    category: '政商内幕',
    categorySlug: 'zhengshang',
    author: '911调查组',
    publishedAt: '2026-08-02T16:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20real%20estate%20construction%20site%20with%20cranes%20against%20grey%20overcast%20sky%2C%20half%20built%20high%20rises%2C%20dramatic%20cloudy%20atmosphere%2C%20corruption%20investigation%20concept%2C%20moody%20and%20serious%20tone%2C%20documentary%20style%20photography&width=800&height=450&seq=zhengshang-02&orientation=landscape',
    tags: ['腐败', '房地产', '副市长', '利益输送'],
    views: 167500,
    isHot: false,
    isExclusive: true,
  },
  {
    id: '7',
    title: '某短视频平台大V被曝刷量造假：直播数据水分高达80%',
    excerpt: '技术团队通过数据分析发现，该平台多位头部大V的直播间存在大量机器人观众，实际观看人数仅为显示数据的五分之一。',
    content: `<p>近日，本网技术团队针对某主流短视频平台的头部大V直播间进行了为期两周的数据监测与分析，结果令人震惊。</p><p>分析报告显示，被监测的10位头部大V中，有7位的直播间存在严重的刷量行为。以粉丝量排名第一的某带货主播为例，其直播间显示的在线人数通常在10万至50万之间，但通过技术手段分析互动数据、弹幕频率和用户行为模式后发现，真实观看人数仅为显示数据的20%左右。</p><p>技术专家指出，这些机器人观众的行为模式高度一致——进入直播间后从不发言、从不点赞、从不购买商品，仅在观看几分钟后自动退出。而这些"观众"的IP地址高度集中，多数来自某几个特定地区的数据中心。</p><p>一位不愿具名的MCN机构负责人透露，刷量在行业内已是公开的秘密。"品牌方看数据投广告，主播就需要把数据做漂亮。现在市面上有专门提供刷量服务的公司，价格从几百到几千元不等，可以按小时购买机器人观众。"</p><p>此报道发布后，该短视频平台股价下跌3.2%。平台方面回应称，将加强技术反作弊措施，对查实的刷量行为将进行封号处理。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    author: '911技术组',
    publishedAt: '2026-08-01T14:30:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20multiple%20computer%20monitors%20displaying%20data%20charts%20and%20graphs%2C%20red%20and%20green%20numbers%20reflecting%2C%20cyber%20investigation%20concept%2C%20mysterious%20hacker%20aesthetic%2C%20warm%20monitor%20glow%20in%20darkness%2C%20tech%20noir%20style&width=800&height=450&seq=wanghong-02&orientation=landscape',
    tags: ['短视频', '刷量', '直播数据', '造假'],
    views: 143200,
    isHot: false,
    isExclusive: false,
  },
  {
    id: '8',
    title: '某连锁餐饮品牌食品安全严重违规：后厨蟑螂遍地，食材过期仍在使用',
    excerpt: '暗访记者在该品牌多家门店后厨拍摄到触目惊心的画面，蟑螂乱爬、过期食材继续使用、员工徒手操作等情况普遍存在。',
    content: `<p>经过长达一个月的卧底暗访，本网记者在某知名连锁餐饮品牌的多家门店后厨拍摄到了令人触目惊心的食品安全问题。</p><p>暗访视频显示，多家门店的后厨卫生状况极其恶劣。在备餐区，蟑螂随处可见，有的甚至爬到了正在准备的食材上。冰箱内，大量食材已经超过保质期，但厨房工作人员仍将其用于制作菜品。</p><p>记者还发现，多家门店存在将顾客退回的菜品重新加工后再次上桌的情况。一些明显已被食用过的凉菜和点心，在被退回后厨后，只是简单整理了一下摆盘就被端给了下一桌客人。</p><p>更令人担忧的是，记者发现该品牌存在系统性的"改标签"行为——即将即将过期食材的保质期标签撕掉，贴上新的标签以延长保质期。内部员工透露，这是店长下达的指令，目的是控制食材成本。</p><p>报道发布后，该品牌所属公司股价暴跌12%，多地市场监管部门已介入调查。公司发表道歉声明，承诺关闭涉事门店进行整改。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    author: '911暗访组',
    publishedAt: '2026-08-02T08:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dirty%20restaurant%20kitchen%20with%20dim%20lighting%2C%20stainless%20steel%20surfaces%2C%20greasy%20walls%2C%20cluttered%20workspace%2C%20food%20safety%20investigation%20concept%2C%20gritty%20realistic%20documentary%20style%2C%20dark%20and%20unsettling%20atmosphere&width=800&height=450&seq=shehui-01&orientation=landscape',
    tags: ['食品安全', '餐饮', '暗访', '过期食材'],
    views: 378900,
    isHot: true,
    isExclusive: true,
  },
  {
    id: '9',
    title: '独家：某知名导演选角潜规则实录，多位女演员勇敢发声',
    excerpt: '三位曾与该导演合作过的女演员联合接受本网专访，首次公开讲述在选角过程中遭遇的不公平对待和潜规则要求。',
    content: `<p>近日，三位曾与某著名导演有过合作的女演员联合接受了本网的独家专访，首次在镜头前公开讲述自己在选角过程中遭遇的种种不公。</p><p>化名为"A女士"的一位演员回忆道："他（指导演）在试镜时就直接说，想要女主角可以，但需要'付出一些代价'。我当时就拒绝了，后来那个角色果然给了别人。"</p><p>另一位化名"B女士"的演员则表示，自己曾在酒店房间被导演以"单独讨论剧本"为名叫去，期间对方多次进行言语挑逗和肢体接触。"我说我要走了，他就威胁说以后在这个圈子里别想再接到戏。"</p><p>第三位受访者"C女士"透露了一个更为系统性的问题——该导演的选角团队会提前筛选女演员的照片和资料，按照外貌身材进行评分，评分较高的才会被推荐给导演进行"二轮面试"，而所谓的"二轮面试"通常安排在私人会所或酒店。</p><p>三位演员均表示，之所以选择现在发声，是因为看到越来越多的女性勇敢站出来揭露行业乱象，她们希望自己的经历能够鼓励更多受害者不再沉默。</p>`,
    category: '独家爆料',
    categorySlug: 'dujia',
    author: '911专访组',
    publishedAt: '2026-08-05T07:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%20with%20spotlights%20casting%20long%20shadows%2C%20dark%20and%20moody%20atmosphere%2C%20Hollywood%20scandal%20concept%2C%20dramatic%20cinematic%20lighting%2C%20behind%20the%20scenes%20exposed%20theme&width=800&height=450&seq=dujia-01&orientation=landscape',
    tags: ['导演', '选角', '潜规则', '女演员'],
    views: 267400,
    isHot: true,
    isExclusive: true,
  },
  {
    id: '10',
    title: '深度调查：某P2P平台爆雷前的最后90天，高管集体套现跑路路线还原',
    excerpt: '通过获取的内部邮件和资金流水，本网还原了该平台在爆雷前三个月内，核心高管团队如何有条不紊地转移资产并策划出境。',
    content: `<p>2025年底，某知名P2P平台突然宣布兑付困难，涉及未兑付资金高达380亿元，波及投资者超过60万人。本网经过数月的调查取证，独家还原了该平台在爆雷前最后90天内，核心高管团队的行动轨迹。</p><p>根据获取的内部邮件显示，早在爆雷前三个月，公司CEO就在一封邮件中写道："冬天快来了，大家做好准备。"此后，一系列资产转移行动有条不紊地展开。</p><p>调查发现，在爆雷前的最后90天里，公司6名核心高管及其亲属名下的银行账户共收到来自公司关联账户的转账共计约12亿元。这些资金被分散转入数十个账户后，又通过地下钱庄汇往境外。</p><p>同时，这些高管的出境记录也颇为蹊跷。CEO在爆雷前两周以"考察海外项目"为由飞往新加坡，之后再未入境。CFO则选择了加拿大作为目的地。目前，6名核心高管中已有5人确认出境，仅COO一人在国内被警方控制。</p><p>本网已将全部调查材料移交给相关监管部门。据悉，公安部已对此案挂牌督办，并已通过国际刑警组织对在逃人员发出红色通缉令。</p>`,
    category: '深度调查',
    categorySlug: 'shendu',
    author: '911调查组',
    publishedAt: '2026-07-28T10:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20luxury%20office%20with%20scattered%20financial%20documents%20on%20floor%2C%20abandoned%20executive%20desk%2C%20dim%20lighting%20through%20blinds%2C%20corporate%20fraud%20investigation%20scene%2C%20dramatic%20shadows%2C%20moody%20documentary%20photography&width=800&height=450&seq=shendu-01&orientation=landscape',
    tags: ['P2P爆雷', '套现跑路', '深度调查', '金融诈骗'],
    views: 198700,
    isHot: false,
    isExclusive: true,
  },
  {
    id: '11',
    title: '某知名网红偷税被罚2.5亿，幕后团队运作模式全解析',
    excerpt: '税务部门公布的最新案例中，一名头部网红主播因偷逃个人所得税被追缴税款并处罚款共计2.5亿元。',
    content: `<p>近日，国家税务总局公布了最新一批涉税违法典型案例，其中一名头部网红主播的偷税案格外引人注目。该主播因通过隐匿收入、转换收入性质等方式偷逃个人所得税，被追缴税款、加收滞纳金并处罚款共计2.5亿元。</p><p>据了解，该主播主要通过以下三种方式偷逃税款：一是将直播打赏收入通过多个支付宝和微信账户分散收取，未如实申报；二是将个人劳务报酬通过名下工作室转化为企业经营收入，适用较低的核定征收税率；三是通过亲属账户收取品牌代言费和商务合作费用。</p><p>业内人士分析指出，该主播的背后运作团队在税务筹划方面可谓"煞费苦心"。其团队专门聘请了税务顾问，设计了一套复杂的收入分流方案，涉及多达十余家关联公司和数十个个人账户。</p><p>税务部门表示，在大数据税收监管体系下，任何企图偷逃税款的行为都将无所遁形。目前，该主播已配合税务机关完成税款补缴，但其个人账号及直播间已被平台永久封禁。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong',
    author: '911编辑部',
    publishedAt: '2026-08-01T20:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20bags%20and%20cash%20scattered%20on%20a%20dark%20table%2C%20tax%20documents%20with%20red%20stamps%2C%20dramatic%20lighting%2C%20wealth%20and%20crime%20concept%2C%20moody%20atmosphere%2C%20financial%20investigation%20theme&width=800&height=450&seq=wanghong-03&orientation=landscape',
    tags: ['网红', '偷税', '罚款', '封禁'],
    views: 312500,
    isHot: true,
    isExclusive: false,
  },
  {
    id: '12',
    title: '某城市地铁工程偷工减料内幕：举报人遭威胁，监理公司同流合污',
    excerpt: '一位在地铁工程中担任技术员的举报人向本网提供了大量施工照片和检测报告，揭露了令人震惊的工程质量问题。',
    content: `<p>本网近日接到一位在某城市地铁工程中担任现场技术员的举报人的实名举报材料。该举报人提供了大量施工现场照片、材料检测报告和内部沟通记录，揭露了工程中系统性的偷工减料问题。</p><p>据举报材料显示，在工程的多处关键部位，施工方使用不符合设计标准的钢筋和混凝土。原设计要求的HRB500级钢筋被替换为低等级的HRB400钢筋，混凝土标号也从设计的C50降低为C35。</p><p>更令人担忧的是，举报人指出监理公司对此不仅知情，而且参与了造假行为。多份检测报告上的数据被篡改，不合格的材料被"验收合格"。举报人曾多次向监理方和业主方反映问题，但均未得到回应。</p><p>举报人表示，在举报材料曝光后，他接到了多个威胁电话，有人暗示"如果不收手，会有严重后果"。举报人已向公安机关报案，目前正在接受警方人身保护。</p><p>该市住建部门回应称，已关注到相关网络信息，将组织专家对涉事工程进行全面质量复查。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    author: '911调查组',
    publishedAt: '2026-07-30T13:00:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Underground%20subway%20tunnel%20construction%20site%20with%20exposed%20rebar%20and%20concrete%2C%20dim%20industrial%20lighting%2C%20safety%20helmets%2C%20construction%20scandal%20concept%2C%20dark%20and%20gritty%20atmosphere%2C%20documentary%20realism&width=800&height=450&seq=shehui-02&orientation=landscape',
    tags: ['地铁工程', '偷工减料', '举报', '监理'],
    views: 225600,
    isHot: false,
    isExclusive: true,
  },
];

export const siteInfo = {
  name: '911黑料网',
  tagline: '独家爆料内容聚合平台',
  description: '911黑料网是专注独家爆料、真实内幕揭秘的内容聚合平台。汇聚娱乐圈、社会热点、明星黑料等第一手资讯，为你呈现最真实、最劲爆的幕后故事。',
  keywords: '911黑料网,黑料爆料网站,娱乐圈黑料,明星内幕爆料,独家黑料资讯,社会热点黑料,真实爆料平台',
  email: 'tips@911heilian.com',
  foundedYear: 2020,
  stats: {
    totalArticles: 476,
    exclusiveArticles: 328,
    dailyVisitors: 1500000,
    verifiedReporters: 42,
  },
};

export const faqs = [
  {
    question: '911黑料网的爆料内容是否真实可靠？',
    answer: '我们坚持"真实第一"的原则。所有爆料内容均经过多源交叉验证，必要时会联系当事人核实。我们对匿名消息来源会标注来源可信度等级，让读者自行判断。同时我们保留所有原始证据材料，随时准备应对法律质询。',
  },
  {
    question: '如何向911黑料网提供爆料线索？',
    answer: '您可以通过以下方式联系我们：发送邮件至 tips@911heilian.com；或使用网站的匿名举报通道。我们承诺对举报人信息严格保密，并按照线索价值给予相应奖励。对于重大独家爆料，奖励金额可达5万至50万元人民币。',
  },
  {
    question: '如果报道内容涉及我本人，如何申请更正或删除？',
    answer: '如您认为我们的报道存在事实性错误，请通过 law@911heilian.com 与我们联系，并提供相关证据。我们会在收到申请后48小时内启动核实程序。如确有不实之处，我们将第一时间发布更正声明。对于诽谤性言论，我们接受法律途径解决。',
  },
  {
    question: '911黑料网的文章版权归谁所有？',
    answer: '本站所有原创文章版权归911黑料网所有。未经授权，任何媒体、网站或个人不得转载、摘编或以其他方式使用本站内容。已获授权的媒体在使用时须注明"来源：911黑料网"并附原文链接。对于侵权行为，我们将依法追究相关责任。',
  },
  {
    question: '网站上的广告内容是否经过审核？',
    answer: '我们对接入的广告内容实行严格的审核制度，拒绝虚假广告、赌博广告和违法违规广告。但同时，我们不对广告主提供的产品或服务承担任何担保责任。如发现广告存在违规行为，请及时向我们举报。',
  },
];

export const testimonials = [
  { name: '匿名读者A', role: '资深媒体人', content: '在这个信息泛滥的时代，911黑料网是为数不多还在坚持做深度调查和独家爆料的平台。每一篇文章都能看出背后大量的调查工作。' },
  { name: '匿名读者B', role: '互联网从业者', content: '关注911已经两年了，很多在其他平台看不到的内容，这里都有。虽然有些爆料过于劲爆让人半信半疑，但事后多次被证实确实是真的，不得不服。' },
  { name: '匿名读者C', role: '金融分析师', content: '911对政商圈子的深度报道非常有价值，很多信息对我判断行业走向和投资决策都有重要参考意义。希望平台能一直保持这种敢说真话的风格。' },
];